import { useEffect } from 'react';

const BASE_TITLE = 'Edwin People';

const PATH_TITLES: Record<string, string> = {
  '/': 'Home',
  '/about': 'About',
  '/login': 'Login',
  '/register': 'Register',
  '/reset-password': 'Reset password',
  '/profile': 'Profile',
  '/resource-hub': 'Resource hub',
  '/knowledge-base': 'Knowledge base',
  '/podcasts': 'Podcasts',
  '/key-dates': 'Key dates',
  '/learn': 'Learn',
  '/search': 'Search',
  '/bookmarks': 'Bookmarks',
  '/leadership-wheel': 'Leadership wheel',
  '/manage-staff': 'Manage staff',
  '/cookies': 'Cookies',
  '/copyright': 'Copyright',
  '/terms-and-conditions': 'Terms and conditions',
  '/privacy-policy': 'Privacy policy',
  '/not-authorized': 'Not authorized',
};

function getTitleForPath(pathname: string): string {
  if (PATH_TITLES[pathname]) {
    return `${BASE_TITLE} - ${PATH_TITLES[pathname]}`;
  }
  if (pathname.startsWith('/on-boarding')) return `${BASE_TITLE} - Onboarding`;
  if (pathname.startsWith('/resource/')) return `${BASE_TITLE} - Resource`;
  if (pathname.startsWith('/knowledge-base/')) return `${BASE_TITLE} - Article`;
  if (pathname.startsWith('/podcasts/')) return `${BASE_TITLE} - Podcast`;
  if (pathname.startsWith('/learn/course/')) return `${BASE_TITLE} - Course`;
  if (pathname.startsWith('/reset-password/')) return `${BASE_TITLE} - Reset password`;
  if (pathname.startsWith('/register/')) return `${BASE_TITLE} - Register`;
  return `${BASE_TITLE} - Home`;
}

export function useDocumentTitle(pathname: string) {
  useEffect(() => {
    document.title = getTitleForPath(pathname);
  }, [pathname]);
}
